module.exports = __webpack_public_path__ + "img/training-empty.e14df7e4.png";